







































































































import { Component, Mixins } from "vue-property-decorator";
import PageView from "@/mixins/page";
import {
  WyreOrder,
  TradeSide,
  WyreOrderStatus
} from "@foxone/api/src/models/market";
import utils from "trade/utils";

@Component
class WyreOrderPage extends Mixins(PageView) {
  order: WyreOrder | null = null;

  loading = false;

  get title() {
    return this.$t("trade.cash-in.order-detail") as string;
  }

  get id() {
    return this.$route.params.id;
  }

  get meta() {
    const destAsset = this.order?.dest_asset;
    const destAssetIcon = destAsset?.icon ?? "";
    const sourceCurrency = this.order?.source_currency ?? "";
    const destCurrency = this.order?.dest_currency ?? "";
    const status = this.order?.status ?? "";
    const sourceAmount = this.order?.source_amount ?? "";
    const sourceAmountWithoutFees =
      this.order?.source_amount_without_fees ?? "";
    this.order?.source_amount_without_fees ?? "";
    const destAmount = this.order?.dest_amount ?? "";
    const dest = this.order?.dest ?? "";
    const createdAt = this.$common.utils.date.formatDate(
      Number(this.order?.created_at ?? "") * 1000,
      "YYYY/MM/DD HH:mm:ss"
    );
    const exchangeRate = this.order?.exchange_rate ?? "";
    const fee =
      Number(this.order?.source_fee ?? "") + Number(this.order?.dest_fee ?? "");

    const sideMeta = utils.enums.getTradeSideMeta(TradeSide.BID);
    const statusMeta = utils.enums.getWyreStatusMeta(
      status || WyreOrderStatus.PROCESSING
    );
    const statusText = this.$t(statusMeta.text);
    const statusColor = statusMeta.color;

    return {
      sideText: this.$t(sideMeta.text),
      sideColor: sideMeta.color,
      destAssetIcon,
      destAsset,
      sourceCurrency,
      destCurrency,
      sourceAmount,
      sourceAmountWithoutFees,
      destAmount,
      exchangeRate,
      fee,
      dest,
      sideMeta,
      statusMeta,
      statusText,
      statusColor,
      createdAt
    };
  }

  async mounted() {
    await this.init();
    this.pullingOrder();
  }

  async init() {
    this.loading = true;
    await this.requestWyreOrder();
    this.loading = false;
  }

  pullingOrder() {
    setTimeout(() => {
      this.requestWyreOrder();
      if (this.order) {
        const isPending = [
          WyreOrderStatus.PROCESSING,
          WyreOrderStatus.RUNNING_CHECKS
        ].includes(this.order.status);
        if (isPending) {
          this.pullingOrder();
        }
      }
    }, 3000);
  }

  async requestWyreOrder() {
    try {
      this.order = await this.$api.market.getWyreOrder(this.id);
    } catch (error) {
      this.$common.utils.helper.errorHandler(this, error);
    }
  }
}
export default WyreOrderPage;
